import { useMemo } from 'react';
import { type DebriefStage } from '@momentum/types';
import type { EditableFact } from '../types';
import { groupFactsByStage, useDebriefV2State } from './DebriefV2StateContext';
import type { FactDraft } from './debriefFactsReducer';

export type { FactDraft } from './debriefFactsReducer';

interface DebriefFactsStateContextValue {
  facts: EditableFact[];
  factsByStage: Partial<Record<DebriefStage, EditableFact[]>>;
  isLoading: boolean;
  editFact: (id: string, draft: FactDraft) => void;
  addFact: (stage: DebriefStage, draft: FactDraft) => void;
}

export function useDebriefFactsState(): DebriefFactsStateContextValue {
  const { facts: factsSlice } = useDebriefV2State();
  const { state, dispatch, isLoading } = factsSlice;

  return useMemo<DebriefFactsStateContextValue>(
    () => ({
      facts: state.facts,
      factsByStage: groupFactsByStage(state.facts),
      isLoading,
      editFact: (id, draft) =>
        dispatch({ type: 'EDIT_FACT', payload: { id, draft } }),
      addFact: (stage, draft) =>
        dispatch({ type: 'ADD_FACT', payload: { stage, draft } }),
    }),
    [state.facts, isLoading, dispatch]
  );
}
